<template>
  <div class="report_format">
    <vs-card id="report_data-loading" v-if="is_form_show">
      <slot name="report-form"></slot>

      <hr class="mt-5 border border-black" />

      <div class="filter__btns text-center">
        <vs-button color="success" class="m-5 mb-0 md:w-1/5" type="filled" @click="$emit('show_result')">{{ formSubmitBtnText }}</vs-button>
        <vs-button color="danger" class="m-5 mb-0 md:w-1/5" type="filled" @click="$router.push({ path: '/' }).catch(() => {})">Close</vs-button>
      </div>
    </vs-card>

    <vs-card id="data-loading" v-if="is_table_show">
      <vs-table id="table-loading" class="vs-con-loading__container" stripe :sst="true" maxHeight="500px" :data="records">
        <template slot="header">
          <!-- TABLE ACTION ROW -->
          <div class="flex flex-wrap justify-between items-center w-full my-3">
            <div class="table_title font-bold text-xl">Records Table</div>

            <div class="flex">
              <div v-if="isSeachAllowed" class="con-input-search vs-table--search p-0 mr-5">
                <input type="text" class="input-search vs-table--search-input" @input="(e) => searchVal(e.target.value)" />
                <vs-icon icon="search"></vs-icon>
              </div>

              <vs-button color="dark" type="filled" @click="$emit('download_excel_report')">Excel</vs-button>
            </div>
          </div>
        </template>

        <slot name="record-table"></slot>
      </vs-table>
    </vs-card>
  </div>
</template>

<script>
export default {
  name: 'ReportFormat',

  props: {
    records: Array,

    is_form_show: {
      type: Boolean,
      default: true
    },

    is_table_show: {
      type: Boolean,
      default: true
    },

    formSubmitBtnText: {
      type: String,
      default: 'Show'
    },

    isSeachAllowed: {
      type: Boolean,
      default: false
    },

    isLoading: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    searchVal(val) {
      this.$emit('search', val)
    }
  },
  watch: {
    isLoading() {
      if (this.isLoading) {
        this.$vs.loading({
          container: '#report_data-loading',
          scale: 0.45
        })
      } else {
        this.$vs.loading.close('#report_data-loading > .con-vs-loading')
      }
    }
  }
}
</script>

<style lang="scss">
.report_format {
  position: initial;

  #report_data-loading {
    position: relative;

    .con-vs-loading {
      position: absolute;
    }
  }

  .vdp-datepicker {
    position: unset;
  }
}
</style>